import React from 'react'

export const ListBullet = ({ children }: { children: any }) => {
  return <ul className="w-full / mb-3 pl-6 / list-disc">{children}</ul>
}
